import { useQuery } from '@tanstack/react-query'
import { reactQueryKeys } from 'reactQueryKeys/reactQueryKeys'
import { getContactInstrument } from 'services/ContactService'
import { ContactInstrumentRequest } from 'types/contacts'

export const useContactInstrumentQuery = ({
  contactId,
  instrumentId,
}: ContactInstrumentRequest) => {
  return useQuery({
    queryKey: reactQueryKeys.contactInstrument(contactId, instrumentId),
    queryFn: () => getContactInstrument({ contactId, instrumentId }),
    enabled: !!contactId && !!instrumentId,
  })
}
